module.exports = __webpack_public_path__ + "static/media/logo.25adf785.jpeg";